export class User {

    _profile: any;
    id: string;
    email: string;
    name: string;
    password: string;
    authenticated: boolean;
    authData: any;
    data: any;

    constructor(profile: any) {
        this._profile = profile;
        Object.keys(profile).forEach((k) => {
            this[k] = profile[k];
        });
    }
}
